export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Initialisierungsfehler",
    "StaticConfigLoader.caption.init": "Initialisierung",
    "StaticConfigLoader.text.init": "Anwendung wird initialisiert ...",
    "StaticConfigLoader.error.settings": "Seiteneinstellungen können nicht geladen werden.",
    "StaticConfigLoader.error.circuits": "Seitenkonfiguration kann nicht geladen werden.",
    //app
    "Legal.Localization": "de",
    "AchievementApp.Navbar.storeTitle": "Shop",
    "AchievementApp.Navbar.supportTitle": "Kundendienst",
    "Legal.TermsConditions": "Geschäftsbedingungen",
    "Legal.TermsService": "Nutzungsbedingungen",
    "Legal.PrivacyPolicy": "Datenschutzerklärung",
    "Legal.CookiesPolicy": "Cookie-Einstellungen",
    "Legal.Copyright": "Alle Markenzeichen, Logos und Markennamen sind das Eigentum ihrer jeweiligen Eigentümer.",
    "AchievementApp.Navbar.achievement": "Persönliche Errungenschaft",
    "AchievementApp.Navbar.userAchievement": "Benutzererrungenschaft",
    "AchievementApp.Navbar.settingsLink": "Einstellungen",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Erneut anmelden oder Konto wechseln",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net-Errungenschaften",
    //commonAssets
    "ViewItemDetailed.state.completed": "Abgeschlossen",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Nach Titel filtern",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Meine Freunde",
    "UserFriendsList.heading.showMore": "Mehr anzeigen",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Du musst die Zwei-Faktor-Authentifizierung aktivieren.",
    "LimitedAccountPanel.2step.link": "Mehr zur Zwei-Faktor-Authentifizierung",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Du musst deine E-Mail-Adresse bestätigen.",
    "LimitedAccountPanel.email.link": "Zum Profil",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Dein Konto ist durch Folgendes limitiert:",
    "LimitedAccountPanel.conclusion": "Nachdem du deine Sicherheitseinstellungen geändert hast, solltest du dich ausloggen und erneut einloggen, damit die Änderungen gelten.",
    "LimitedAccountPanel.relogin": "Neu anmelden",
    "EmailVerificationStateIcon.success": "Konto bestätigt, E-Mail-Adresse verifiziert",
    "EmailVerificationStateIcon.warning": "Konto nicht bestätigt, E-Mail-Adresse nicht verifiziert",
    "EmailVerificationStateIcon.danger": "Konto nicht bestätigt, E-Mail-Adresse MUSS verifiziert werden",
    "TwoFactorStateIcon.success": "Konto mit Zwei-Faktor-Authentifizierung gesichert",
    "TwoFactorStateIcon.warning": "Unsicheres Konto, Zwei-Faktor-Authentifizierung deaktiviert",
    "TwoFactorStateIcon.danger": "Zwei-Faktor-Authentifizierung NÖTIG",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Einstellungen speichern",
    "UserSettingDialog.settings": "Einstellungen",
    "UserSettingDialog.userSettings": "Benutzereinstellungen",
    "UserSettingDialog.language": "Sprache",
    "UserSettingDialog.privacy": "Privatsphäre",
    "UserSettingDialog.allUsers": "Alle Benutzer",
    "UserSettingDialog.friendsOnly": "Nur Freunde",
    "UserSettingDialog.onlyMe": "Nur ich",
    "UserSettingDialog.whoCanView": "Wer kann meine Errungenschaften sehen",
    //unlockProgress
    "ViewUnlockProgress.of": " von ",
    "ViewUnlockProgress.achievCompleted": " Errungenschaften abgeschlossen",
    "ViewUnlockProgress.myUnlock": "Meine Errungenschaften",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Nickname hier suchen",
    "ViewItemSearch.label.search": "Nach Benutzern suchen",
    "ViewItemSearch.resultNotFound": "Benutzer nicht gefunden",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Errungenschaft",
    "ViewItemSearch.stub.empty": "Keine Errungenschaften",
    "ViewItemSearch.stub.emptyCompare_1": "Benutzer ",
    "ViewItemSearch.stub.emptyCompare_2": " hat keine Errungenschaften in diesem Spiel",
    "ViewItemSearch.limitedAccess": "Der Zugriff auf die Errungenschaften des ausgewählten Spielers ist beschränkt.",
    "ViewItemSearch.heading.selectGame": "Spiel aus der Liste wählen",
    "ViewItemSearch.globalstat.opened": "freigeschaltet von ",
    "ViewItemSearch.globalstat.ofGamers": "% der Spieler",
    //authentication
    "NotAllowedMessage.caption": "Nicht erlaubt",
    "NotAllowedMessage.body.h1": "Zugriff auf Errungenschaft",
    "NotAllowedMessage.body.h3": "derzeit für dein Konto nicht erlaubt",
    "NotAllowedMessage.relogin": "Konto wechseln",
    "LandingMessage.caption": "Authentifizierung",
    "LandingMessage.body": "Landung wird abgeschlossen ...",
    "TokenExpiredMessage.caption": "Authentifizierung abgelaufen",
    "TokenExpiredMessage.body.h3": "Wir können nicht viel tun, aber du kannst dich",
    "TokenExpiredMessage.relogin": "neu anmelden",
    "AuthErrorMessage.caption": "Authentifizierung fehlgeschlagen",
    "AuthErrorMessage.body.h1": "Authentifizierung konnte nicht überprüft werden",
    "AuthErrorMessage.body.code": "Code",
    "AuthErrorMessage.body.desc": "Wir können nicht viel tun, aber du kannst dich",
    "AuthErrorMessage.relogin": "neu anmelden",
    "AuthorizationRequiredMessage.caption": "Authentifizierung nötig",
    "AuthorizationRequiredMessage.body.h3.1": "Du betrittst",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Du musst dich authentifizieren, um fortzufahren",
    "AuthorizationRequiredMessage.login": "Mit Gaijin.Net anmelden",
    "CheckingAuthMessage.caption": "Authentifizierung",
    "CheckingAuthMessage.body": "Authentifizierung wird geprüft. Bitte warten.",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Die mobile Version ist vorübergehend nicht verfügbar.",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Bitte nutze die Computer-Version.",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Es tut uns leid.",
}